module.exports = __webpack_public_path__ + "static/Group 31-9e82b16f5f43dc7eabbb99337827fa42.svg";